import { TournamentBrackets } from './tournament-brackets';
import { useRouteLoaderData } from 'react-router';
import { tournamentRouteId } from './layout';
import { OkStatusIndicator, NotOkStatusIndicator } from '@repo/ui/components/status-indicator';
import { DataTable } from '@repo/ui/components/data-table';
import { Registration } from '@repo/shared-types';
import { Check, Hourglass, UserX } from 'lucide-react';

interface RegistrationWithInterests extends Registration {
  timeInterests?: Array<{
    id: string;
    confirmed: boolean;
  }>;
}

type ScheduleStatus = 'waiting_list' | 'pending_assignment' | 'assigned';

function getScheduleStatus(registration: RegistrationWithInterests): ScheduleStatus {
  if (!registration.timeInterests || registration.timeInterests.length === 0) {
    return 'waiting_list';
  }

  return registration.timeInterests.some((interest) => interest.confirmed)
    ? 'assigned'
    : 'pending_assignment';
}

function ScheduleStatusIcon({ status }: { status: ScheduleStatus }) {
  switch (status) {
    case 'waiting_list':
      return <UserX className="w-4 h-4 text-red-500" />;
    case 'pending_assignment':
      return <Hourglass className="w-4 h-4 text-orange-500" />;
    case 'assigned':
      return <Check className="w-4 h-4 text-green-600" />;
  }
}

const columns = [
  {
    header: 'Jugador 1',
    accessorKey: 'playerOne',
  },
  {
    header: 'Jugador 2',
    accessorKey: 'playerTwo',
  },
  {
    header: 'Categoría',
    accessorKey: 'category',
    cell: ({ row }: { row: { original: Registration } }) => {
      return row.original.category.name;
    },
  },
  {
    header: 'Confirmado',
    accessorKey: 'confirmed',
    cell: ({ row }: { row: { original: Registration } }) => {
      return row.original.confirmed ? <OkStatusIndicator /> : <NotOkStatusIndicator />;
    },
  },
  {
    header: 'Horario',
    accessorKey: 'timeInterests',
    cell: ({ row }: { row: { original: RegistrationWithInterests } }) => {
      return <ScheduleStatusIcon status={getScheduleStatus(row.original)} />;
    },
  },
  {
    header: 'Celular',
    accessorKey: 'phone',
    className: 'hidden md:table-cell',
  },
];

function InscriptionOnlyFinished() {
  const { tournament } = useRouteLoaderData(tournamentRouteId);
  return (
    <DataTable
      total={tournament?.registrations.length ?? 0}
      columns={columns}
      data={tournament?.registrations as RegistrationWithInterests[]}
    />
  );
}

function Finished() {
  const { tournament } = useRouteLoaderData(tournamentRouteId);
  if (tournament?.mode === 'INSCRIPTION_ONLY') {
    return <InscriptionOnlyFinished />;
  }
  return <TournamentBrackets readonly />;
}

export const route = {
  index: true,
  path: 'finished',
  element: <Finished />,
};
